// Copyright 2021 The Casdoor Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import React from "react";
import {Button, Col, Input, Radio, Row, Select, Tag, Tooltip} from "antd";
import * as SyncerBackend from "../../services/SyncerBackend";
import * as OrganizationBackend from "../../services/OrganizationBackend";
import * as Setting from "../../conf/Setting";
import i18next from "i18next";
import moment from "moment";
import {v4 as uuidv4} from "uuid";
import DepartmentSelectModal from "../../components/user/DepartmentSelectModal";
import "./SyncerManagement.less";
import {CopyOutlined} from "@ant-design/icons";
import copy from "copy-to-clipboard";

const {Option} = Select;

class DownstreamSyncerEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      classes: props,
      syncerId: props.match.params.syncerId,
      owner: props.match.params.owner,
      syncer: null,
      organizations: [],
      mode: props.mode === "add" ? "add" : "edit",
      saveLoading: false,
      userTranferModalVisible: false,
    };
  }

  newSyncer() {
    const randomName = Setting.getRandomName();
    return {
      owner: "",  // 组织uid
      uid: uuidv4(),
      displayName: `syncer_${randomName}`,  // 名称
      syncType: 0, // 同步类型
      isSyncAll: true, // 是否同步全部
      syncRange: [], // 同步范围 范围以部门进行区分
      syncId: "", // syncId 提供给第三方调用接口时使用
      syncKey: "", // syncKey 提供给第三方调用接口时使用
      isEnabled: true, // 启用禁用

      createdTime: moment().format("yyyy-MM-DD HH:mm:ss"),
      updatedTime: moment().format("yyyy-MM-DD HH:mm:ss"),
    };
  }

  UNSAFE_componentWillMount() {
    if (this.state.mode === "add") {
      const syncer = this.newSyncer();
      this.setState({syncer: syncer});
    } else {
      this.getSyncer(this.state.syncerId, this.state.owner);
    }

    this.getOrganizations();
  }

  getSyncer(syncerId, owner) {
    SyncerBackend.getDownstreamSyncerById(syncerId, owner)
      .then((res) => {
        if (res.msg === undefined) {
          this.setState({
            syncer: res,
          });
        }
      });
  }

  getOrganizations() {
    OrganizationBackend.getOrganizations(Setting.Admin)
      .then((res) => {
        if (res.msg === undefined) {
          const org = res.filter(organization => !Setting.isAdminOrganization(organization.uid)).reverse();
          this.setState({
            organizations: org,
          });
          if (this.state.mode === "add") {
            this.updateSyncerField("owner", org.length > 0 ? org[0].uid : "");
          }
        } else {
          this.setState({
            organizations: [],
          });
        }
      });
  }

  parseSyncerField(key, value) {
    if (["port"].includes(key)) {
      value = Setting.myParseInt(value);
    }
    return value;
  }

  updateSyncerField(key, value) {
    value = this.parseSyncerField(key, value);

    const syncer = this.state.syncer;
    syncer[key] = value;
    this.setState({
      syncer: syncer,
    });
  }

  renderTaskConfig() {
    return <div>
      <Row style={{marginTop: "10px"}} >
        <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
          {Setting.getLabel(i18next.t("general:Organization"), i18next.t("general:Organization - Tooltip"), true)} :
        </Col>
        <Col span={22} >
          <Select virtual={false} style={{width: "100%"}} value={this.state.syncer.owner} onChange={(value => {
            this.updateSyncerField("owner", value);
            this.updateSyncerField("syncRange", []);
          })}>
            {
              this.state.organizations.map((organization, index) => <Option key={index} value={organization.uid}>{organization.displayName}</Option>)
            }
          </Select>
        </Col>
      </Row>
      <Row style={{marginTop: "20px"}} >
        <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
          {Setting.getLabel(i18next.t("general:Name"), i18next.t("general:Name - Tooltip"), true)} :
        </Col>
        <Col span={22} >
          <Input value={this.state.syncer.displayName} maxLength={50} showCount onChange={e => {
            this.updateSyncerField("displayName", e.target.value);
          }} />
        </Col>
      </Row>
      <Row style={{marginTop: "20px"}} >
        <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
          {Setting.getLabel(i18next.t("syncer:Sync type"), i18next.t("syncer:Sync type - Tooltip"))} :
        </Col>
        <Col span={22} >
          <Select virtual={false} style={{width: "100%"}} value={this.state.syncer.syncType} onChange={(value => {
            this.updateSyncerField("syncType", value);
          })}>
            {
              Setting.downstreamSyncTypes.map((syncType, index) => <Option key={index} value={syncType.id}>{syncType.name}</Option>)
            }
          </Select>
        </Col>
      </Row>
      <Row style={{marginTop: "20px"}} >
        <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
          {Setting.getLabel(i18next.t("syncer:Sync range"), i18next.t("syncer:Sync range - Tooltip"))} :
        </Col>
        <Col span={22} >
          <Radio.Group onChange={(e) => {
            this.updateSyncerField("isSyncAll", e.target.value);
            this.updateSyncerField("syncRange", []);
          }} value={this.state.syncer.isSyncAll}>
            <Radio value={true}>{i18next.t("syncer:Sync all")}</Radio>
            <Radio value={false}>{i18next.t("syncer:Sync part")}</Radio>
          </Radio.Group>
          {
            this.state.syncer.isSyncAll ?
              null :
              <div className="downstream-sync-tag-container" onClick={() => {
                this.setState({userTranferModalVisible: true});
              }}>
                {
                  this.state.syncer.syncRange.map(item => <Tag color="#aaa" style={{marginTop: 5}} data-deptid={item.deptId} key={item.deptId} closable
                    onClose={(e) => {
                      e.preventDefault();
                      const removeId = e.currentTarget.parentNode.dataset.deptid;
                      const syncRange = this.state.syncer.syncRange.filter(range => range.deptId !== removeId);
                      this.updateSyncerField("syncRange", syncRange);
                    }}>{item.displayName}</Tag>)
                }
              </div>
          }
        </Col>
      </Row>
      {
        this.state.syncer.syncId ?
          <Row style={{marginTop: "20px"}} >
            <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
              {Setting.getLabel(i18next.t("ID"), i18next.t("ID"))} :
            </Col>
            <Col span={22} >
              <Row type="flex">
                <div style={{flex: 1}}><Input value={this.state.syncer.syncId} disabled /></div>
                <Tooltip title={""}>
                  <Button icon={<CopyOutlined />} onClick={() => {
                    copy(this.state.syncer.syncId);
                    Setting.showMessage("success", i18next.t("application:ID copied to clipboard successfully"));
                  }} />
                </Tooltip>
              </Row>
            </Col>
          </Row>
          :
          null
      }
      {
        this.state.syncer.syncKey ?
          <Row style={{marginTop: "20px"}} >
            <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
              {Setting.getLabel(i18next.t("Key"), i18next.t("Key"))} :
            </Col>
            <Col span={22} >
              <Row type="flex">
                <div style={{flex: 1}}><Input value={this.state.syncer.syncKey} disabled /></div>
                <Tooltip title={""}>
                  <Button icon={<CopyOutlined />} onClick={() => {
                    copy(this.state.syncer.syncKey);
                    Setting.showMessage("success", i18next.t("application:Key copied to clipboard successfully"));
                  }} />
                </Tooltip>
              </Row>
            </Col>
          </Row>
          :
          null
      }
      <DepartmentSelectModal visible={this.state.userTranferModalVisible}
        dismiss={() => this.setState({userTranferModalVisible: false})}
        confirmLoading={false}
        organId={this.state.syncer.owner}
        isOrgSelectDisabled={false}
        onConfirmSelect={(transferedNodes) => {
          const transferDepts = transferedNodes.map(node => {
            return {
              code: node.code, // 当前部门或组织的code
              deptId: node.uid, // 当前部门或组织的uid （必填）
              isDept: node.level === 0 ? false : true, // 是组织还是部门 0组织, 1部门 (必填)
              displayName: node.displayName,
              wholePath: node.wholePath,
            };
          });
          this.updateSyncerField("syncRange", transferDepts);
          this.setState({userTranferModalVisible: false});
        }}
      />
    </div>;
  }

  submitSyncerEdit(willExit) {
    const syncer = Setting.deepCopy(this.state.syncer);
    if (syncer.displayName === "") {
      Setting.showMessage("error", i18next.t("名称不能为空"));
      return;
    }
    this.setState({saveLoading: true});
    if (this.state.mode === "add") {
      SyncerBackend.addDownstreamSyncer(syncer)
        .then((res) => {
          if (res.msg === "") {
            Setting.showMessage("success", i18next.t("general:Successfully saved"));

            if (willExit) {
              this.exit();
            } else {
              this.setState({
                syncerId: syncer.uid,
                owner: syncer.owner,
                mode: "edit",
              });
              this.props.history.replace(`/syncers/downstream/${syncer.owner}/${syncer.uid}`);
              this.getSyncer(syncer.uid, syncer.owner);
            }
          } else {
            Setting.showResponseMessage(res.msg);
          }
          this.setState({saveLoading: false});
        })
        .catch(error => {
          Setting.showResponseMessage(error);
          this.setState({saveLoading: false});
        });
    } else {
      SyncerBackend.updateDownstreamSyncer(this.state.syncerId, this.state.owner, syncer)
        .then((res) => {
          if (res.msg === "") {
            Setting.showMessage("success", i18next.t("general:Successfully saved"));

            if (willExit) {
              this.exit();
            } else {
              this.setState({
                owner: syncer.owner,
              });
              this.props.history.replace(`/syncers/downstream/${syncer.owner}/${syncer.uid}`);
            }
          } else {
            Setting.showResponseMessage(res.msg);
          }
          this.setState({saveLoading: false});
        })
        .catch(error => {
          Setting.showResponseMessage(error);
          this.setState({saveLoading: false});
        });
    }

  }

  deleteSyncer() {
    SyncerBackend.deleteSyncer(this.state.syncer)
      .then(() => {
        this.props.history.push("/syncers");
      })
      .catch(error => {
        Setting.showResponseMessage(error);
      });
  }

  exit() {
    this.props.history.push("/syncers");
  }

  render() {
    return (
      <div>
        {
          this.state.syncer ?
            this.renderTaskConfig()
            :
            null
        }
        <div style={{marginTop: "20px", marginLeft: "40px"}}>
          <Button style={{marginLeft: "20px"}} onClick={() => this.exit()}>{i18next.t("general:Cancel")}</Button>
          <Button style={{marginLeft: "20px"}} loading={this.state.saveLoading} onClick={() => this.submitSyncerEdit(false)}>{i18next.t("general:Save")}</Button>
          <Button style={{marginLeft: "20px"}} loading={this.state.saveLoading} type="primary" onClick={() => this.submitSyncerEdit(true)}>{i18next.t("general:Save & Exit")}</Button>
        </div>
      </div>
    );
  }
}

export default DownstreamSyncerEdit;
